module.exports = "pegasus_template/assets/blocks/header-6-theme2.png";